import React, { useState } from 'react';
import HeaderMain from "../components/header/HeaderMain";
import NavMain from "../components/nav/NavMain";
import AutosuggestComponent from "../document/AutosuggestComponent";
import DocumentAffidavitOfConfirmationOfATMCardAsAPayrollAccount from '../document/DocumentAffidavitOfConfirmationOfATMCardAsAPayrollAccount';


function AffidavitOfConfirmationOfATMCardAsAPayrollAccount() {
    const [applicantDetails, setApplicantDetails] = useState(null);
    const [loanProcessingDetails, setLoanProcessingDetails] = useState([]);

    return (
        <>
            <NavMain slug="affidavit-of-confirmation-of-atm-card-as-a-payroll-account" parent="5" />
            <HeaderMain slug="affidavit-of-confirmation-of-atm-card-as-a-payroll-account" />
            <div className="main-content documents">
                <AutosuggestComponent
                setApplicantDetails={setApplicantDetails}
                setLoanProcessingDetails={setLoanProcessingDetails}
                />
                <DocumentAffidavitOfConfirmationOfATMCardAsAPayrollAccount
                    applicantDetails={applicantDetails}
                    loanProcessingDetails={loanProcessingDetails}
                />
            </div>
        </>
    );
}

export default AffidavitOfConfirmationOfATMCardAsAPayrollAccount;